(function () {
    var typed = '';
    var TRIGGER = 'jest';

    document.addEventListener('keypress', function (e) {
        typed += e.key.toLowerCase();
        if (typed.length > TRIGGER.length) typed = typed.slice(-TRIGGER.length);
        if (typed === TRIGGER) { typed = ''; spawnJest(); }
    });

    if (decodeURIComponent(window.location.pathname).includes('/bücher/unendlicher-spass')) {
        setTimeout(spawnJest, 700);
    }

    function spawnJest() {
        if (document.querySelector('.jest-overlay')) return;

        var overlay = document.createElement('div');
        overlay.className = 'jest-overlay';

        var title = document.createElement('div');
        title.className = 'jest-title';
        title.textContent = 'Enfield Tennis Academy';

        var court = document.createElement('div');
        court.className = 'jest-court';

        var net = document.createElement('div');
        net.className = 'jest-net';

        var baseline = document.createElement('div');
        baseline.className = 'jest-baseline';

        var ballX = document.createElement('div');
        ballX.className = 'jest-ball-x';

        var ballY = document.createElement('div');
        ballY.className = 'jest-ball-y';

        var ball = document.createElement('div');
        ball.className = 'jest-ball';
        ball.innerHTML = '<svg viewBox="0 0 44 44" width="44" height="44" xmlns="http://www.w3.org/2000/svg">'
            + '<circle cx="22" cy="22" r="21" fill="#c4e200"/>'
            + '<path d="M10,7 Q22,22 10,37" fill="none" stroke="white" stroke-width="2.8" stroke-linecap="round" opacity="0.82"/>'
            + '<path d="M34,7 Q22,22 34,37" fill="none" stroke="white" stroke-width="2.8" stroke-linecap="round" opacity="0.82"/>'
            + '</svg>';

        ballY.appendChild(ball);
        ballX.appendChild(ballY);
        court.appendChild(net);
        court.appendChild(baseline);
        court.appendChild(ballX);

        var caption = document.createElement('div');
        caption.className = 'jest-caption';
        caption.textContent = '„I am in here."';

        overlay.appendChild(title);
        overlay.appendChild(court);
        overlay.appendChild(caption);

        var closeBtn = document.createElement('button');
        closeBtn.className = 'ee-close';
        closeBtn.textContent = '×';
        closeBtn.addEventListener('click', function () {
            overlay.classList.add('jest-overlay--fade');
            setTimeout(function () { overlay.remove(); }, 1200);
        });
        overlay.appendChild(closeBtn);
        document.body.appendChild(overlay);

        setTimeout(function () {
            overlay.classList.add('jest-overlay--fade');
            setTimeout(function () { overlay.remove(); }, 1200);
        }, 5500);
    }
})();
